import mitt from 'mitt'
import { logger } from '@/logger'

const emitter = mitt()

export const EventBus = {
  on(...args) {
    logger.debug('[EventBus] subscribing to ' + args[0])
    emitter.on(...args)
  },
  off(...args) {
    logger.debug('[EventBus] unsubscribing from ' + args[0])
    emitter.off(...args)
  },
  emit(...args) {
    if (args[0] === undefined) {
      logger.error('[EventBus] received undefined event')
    }
    logger.debug('[EventBus] emitting ' + args[0])
    emitter.emit(...args)
  },
  once(type, handler) {
    const fn = (...args) => {
      emitter.off(type, fn)
      handler(...args)
    }
    emitter.on(type, fn)
  }
}

export const Events = Object.freeze({
  PRINT_STORE_UPLOAD_COMPLETE: 'PRINT_STORE_UPLOAD_COMPLETE',
  CATEGORY_UPDATED: 'CATEGORY_UPDATED',
  COLLECTION_UPDATED: 'COLLECTION_UPDATED',
  CATEGORY_CONTENT_UPDATED: 'CATEGORY_CONTENT_UPDATED',
  LOGGED_IN: 'LOGGED_IN',
  LOGGED_OFF: 'LOGGED_OFF',
  LOGIN_CANCELLED: 'LOGIN_CANCELLED',
  NEW_VERSION_AVAILABLE: 'NEW_VERSION_AVAILABLE',
  ADD_FILE_STORE_FILES_TO_SELECTION: 'ADD_FILE_STORE_FILES_TO_SELECTION',
  FILES_TRASHED: 'FILES_TRASHED',
  REQUEST_LOGIN: 'REQUEST_LOGIN',
  FOLDER_NOT_FOUND: 'FOLDER_NOT_FOUND',
  ENABLE_GTM: 'ENABLE_GTM',
  SHOW_COOKIE_DIALOG: 'SHOW_COOKIE_DIALOG'
})
